import React, { CSSProperties } from 'react';
import classnames from 'classnames';
import { Icon } from '@instinet-analytics/semantic-ui-components';
import './ShowHideToggle.scss';
import Tooltip, { TooltipText } from 'utils/components/Tooltip/Tooltip';
import { IconNames } from '@instinet-analytics/semantic-ui-components';

export type ShowHideToggleStatus = 'show' | 'hide';

type ButtonDirections = 'down' | 'up' | 'right' | 'left';

export interface ShowHideToggleProps {
    hideLabel?: boolean;
    className?: string;
    showDirection?: ButtonDirections;
    tooltip?: TooltipText | string;
    status: ShowHideToggleStatus;
    style?: CSSProperties;
    onToggle?: () => void;
}

export default function ShowHideToggle(props: ShowHideToggleProps) {
    const { className, status, style, onToggle, hideLabel, tooltip } = props;

    const showDirection = props.showDirection || 'down';
    const hideDirection = getHideDirection(showDirection);
    const showIcon = `angle ${showDirection}` as IconNames;
    const hideIcon = `angle ${hideDirection}` as IconNames;
    const horizontal = showDirection === 'left' || showDirection === 'right';

    return (
        <div
            className={classnames(
                'ShowHideToggle',
                status,
                hideLabel && 'hide-label',
                horizontal && 'horizontal',
                className
            )}
            onClick={onToggle}
            style={style}
        >
            <Tooltip text={tooltip} neverHide={true}>
                {status === 'show' ? (
                    <div className="show-hide-button show-button">
                        {!hideLabel && <div className="toggle-text">Show</div>}
                        <Icon name={showIcon} />
                    </div>
                ) : (
                    <div className="show-hide-button hide-button">
                        {!hideLabel && <div className="toggle-text">Hide</div>}
                        <Icon name={hideIcon} />
                    </div>
                )}
            </Tooltip>
        </div>
    );
}

function getHideDirection(showDirection: ButtonDirections): ButtonDirections {
    switch (showDirection) {
        case 'down':
            return 'up';
        case 'up':
            return 'down';
        case 'right':
            return 'left';
        case 'left':
            return 'right';
    }
}
